module.exports = __webpack_public_path__ + "img/cubes-white.24a37230.png";